import React, { useState, useEffect } from "react";

import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import axios from "axios";
import { Toasts } from "../toasts";
import { ActualizarUsuario } from "./modalUsuarioCompra";
import { CambiarClave } from "../comun/modalCambiarClave";
import { PrimaryButton } from "../../ui/buttons/Button";
import { SearchInput } from "../../ui/inputs/Input";
import { ActualizarUsuarioGeneral } from "../modalesGenerales/modalUsuario";
import CardsModule from "../cartas";

const headCells = [
  {
    id: "idinmueble",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numficha",
    label: "USUARIO",
    width: "70px",
    textAlign: "left",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "nombrepropie",
    label: "NOMBRES",
    width: "250px",
    textAlign: "left",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "dirinmueble",
    label: "OPCIONES",
    width: "250px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaUsuarioCompra(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [values, setValues] = useState({});
  const [persona, setPersona] = useState();
  const [usuarioH, setUsuarioH] = useState();
  const [idUsuario] = useState();
  const [usuariow, setUsuariow] = useState();
  const [mostrar2, setMostrar2] = useState(false);
  const [credito, setCredito] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [operacion, setOperacion] = useState();
  const [inmueble, setInmueble] = useState();
  const permiso = JSON.parse(localStorage.getItem("accusuariocompra"));
  const [records, setRecords] = useState([]);
  const [cartas, setCartas] = useState({
    total: 0,
    activos: 0,
    inactivos: 0,
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [deshabilitado] = useState(false);
  const [configCome] = useState();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const renderizar = () => {
    setMostrar5(false);
    setPersona();
    setUsuarioH();
    seleccionarUsuarios();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const seleccionarUsuarios = () => {
    setActivate(true);

    let endpoint = op.conexion + `/api/comprasAlmacen/modulouser`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setCartas({
              total: response.data.length,
              activos: response.data[0].total_activos,
              inactivos: response.data[0].total_inactivos,
            });
            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
    //selectUsu();
  };

  const gestionarUsuario = (index, op, per) => (event) => {
    event.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        setIdUsuarioH(index.idusuario);
        setValues(index);

        setActivate(true);

        setPersona({
          cedula: index.cedula,
          nombres: index.nombres,
          apellidos: index.apellidos,
          correoe: index.correoe,
          tlf1: index.tlf1,
          tlf2: index.tlf2,
          fnacimiento: index.fnacimiento,
          nacionalidad: index.nacionalidad,
          sexo: index.sexo,
          direccion: index.direccion,
        });
        setUsuarioH(index);
        setMostrar5(true);
        setActivate(false);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
              ? "No posee permiso para Editar"
              : op === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }

    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    window.location.href = "/usuariosHacienda";
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };
  const permisosConfig = [
    {
      label: "Registro de Proveedores",
      key: "accproveedor",
      type: "check",
      tab: "Compras",
      valor: "0000",
    },
    {
      label: "Registro de Unidad de Medida",
      key: "accunimedi",
      type: "check",
      tab: "Compras",
      valor: "0000",
    },
    {
      label: "Registro de Tipos de Productos",
      key: "acctipoproducto",
      type: "check",
      tab: "Compras",
      valor: "0000",
    },
    {
      label: "Registro de Productos",
      key: "accproducto",
      type: "check",
      tab: "Compras",
      valor: "0000",
    },
    /* {
      label: "Requisición",
      key: "accrequisicion",
      type: "check",
      tab: "Compras",
      valor: "0000",
    }, */
    {
      label: "Solicitud de Compras",
      key: "accsolicompra",
      type: "check",
      tab: "Compras",
      valor: "0000",
    },

    {
      label: "Aprobar Solicitud de Compra",
      key: "accaprosolicompra",
      type: "radio",
      tab: "Compras",
      valor: "0",
    },

    {
      label: "Listados Generales",
      key: "acclisgencompraalmacen",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },
    {
      label: "Listados de Solicitudes",
      key: "acclissolicompraalmacen",
      type: "radio",
      tab: "Reportes",
      valor: "0",
    },

    {
      label: "Módulo de Usuarios (Compra)",
      key: "accusuariocompra",
      type: "check",
      tab: "Configuracion",
      valor: "0000",
    },
  ];

  const misTabs = [
    {
      id: "tab-datos",
      label: "Datos del Usuario", // Puedes cambiar el nombre
      type: "static",
      colorClass: "bg-blue-100 text-dark text-uppercase fw-bold",
    },
    {
      id: "tab-permisos",
      label: "Seguridad y Permisos",
      type: "dynamic",
      colorClass: "bg-blue-200 text-dark text-uppercase fw-bold",
      // Define explícitamente qué sub-tabs mostrar y en qué orden
      subTabs: [
        {
          id: "sub-compras",
          label: "Compras",
          filterValue: "Compras",
          colorClass: "bg-blue-100 text-dark text-uppercase fw-bold",
        },
        {
          id: "sub-reportes",
          label: "Reportes",
          filterValue: "Reportes",
          colorClass: "bg-blue-200 text-dark text-uppercase fw-bold",
        },
        {
          id: "sub-config",
          label: "Configuración",
          filterValue: "Configuracion",
          colorClass: "bg-blue-300 text-dark text-uppercase fw-bold",
        },
      ],
    },
  ];
  const cerrar = () => {
    props.menu();
  };

  return (
    <div style={styles.parent}>
      <div style={styles.div1}>
        <CardsModule
          total={cartas["total"]}
          activos={cartas["activos"]}
          inactivos={cartas["inactivos"]}
        />
      </div>
      <div style={styles.div2}>
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
          <h3 className="fw-bold m-0">Usuarios</h3>
          <a onClick={cerrar} type="button" className="text-light fw-bold">
            Salir<i className="fas fa-times ms-2"></i>
          </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <SearchInput placeholder="Buscar" onChange={handleSearch} />
          </div>
          <div className="col-auto m-0 p-0 d-flex gap-2">
            <PrimaryButton
              icon="fa-key"
              disabled={
                permiso &&
                permiso.substring(1, 2) !== "1" &&
                permiso.substring(2, 3) !== "1"
              }
              onClick={cambiarClave}
            >
              Cambiar Clave
            </PrimaryButton>
            <PrimaryButton
              icon="fa-plus m-0"
              onClick={gestionarUsuario(
                "",
                1,
                permiso.toString().substring(1, 2),
              )}
              disabled={permiso.toString().substring(1, 2) !== "1"}
            ></PrimaryButton>
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idusuario} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idusuario}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.login}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.nombres}
                    </td>

                    <td
                      align="center"
                      className="align-baseline"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "180px",
                        padding: 0,
                      }}
                    >
                      <button
                        onClick={gestionarUsuario(
                          item,
                          4,
                          permiso.toString().substring(0, 1),
                        )}
                        className={
                          permiso.toString().substring(0, 1) === "1"
                            ? "btn btn-sm btn-info rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={gestionarUsuario(
                          item,
                          2,
                          permiso.toString().substring(2, 3),
                        )}
                        className={
                          permiso.toString().substring(2, 3) === "1"
                            ? "btn btn-sm btn-warning rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={gestionarUsuario(
                          item,
                          3,
                          permiso.toString().substring(3, 4),
                        )}
                        className={
                          permiso.toString().substring(3, 4) === "1"
                            ? "btn btn-sm btn-danger rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-trash-alt"></i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CambiarClave show={mostrar2} onHide={handleCloseClave} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ActualizarUsuarioGeneral
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={values}
        datospersonales={persona}
        permisosConfig={permisosConfig}
        tabsConfig={misTabs}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        render={renderizar}
      />
    </div>
  );
}
const styles = {
  parent: {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gridColumnGap: "20px",
    gridRowGap: "20px",
    height: "100vh",
    padding: "20px",
    backgroundColor: "#f5f5f5",
  },
  div1: {
    gridArea: "1 / 1 / 2 / 2",
  },
  div2: {
    gridArea: "2 / 1 / 3 / 2",
    overflow: "auto",
  },
  div3: {
    gridArea: "1 / 2 / 3 / 3",
    height: "82vh",
  },
};

export default TablaUsuarioCompra;
